import { CircularProgress, Grid } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import SupersetGraph from './SupersetGraph';
import HomeDashboard from './HomeDashboard';
import SensorHealth from '../Dashboard/SensorHealth';
import { getETPEnergyIndexQueryData, getETPOpexCostIndexQueryData, getETPWaterBalanceQueryData, getSTPEnergyIndexQueryData, getSTPOpexCostIndexQueryData, getSTPWaterBalanceQueryData, getWTPWaterQualityParamIndexQueryData, getWTPEnergyIndexQueryData, getWTPWaterBalanceQueryData, getSTPWaterQualityParamIndexQueryData } from '../../Redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment'; 
import SustainabilityGraphs from './SustainabilityGraphs';

export default function SupersetDashboard(props) {

    const { dashboardType, dashboardList = [], client_id = null, facility_ids = [], projectList = [], dList,
        dashboardHeight, showDashboard, loadDashboard } = props;
    const [showLoader, setShowLoader] = useState(true);
    const [supersetResourceList, setSupersetResourceList] = useState([]);
    const [supersetGuestToken, setSupersetGuestToken] = useState(null);
    const [homeDashboardData, setHomeDashboardData] = useState({});

    useEffect(() => {
        if (dashboardType !== 'Home') {
            return
        }
        const params = {
            pids: projectList,
        }
        axios.get('/papi/v1/home-dashboard/', { params })
            .then((response) => {
                setShowLoader(false);
                if (response?.data) {
                    setHomeDashboardData(response?.data)
                }
            })
            .catch((error) => {
                setShowLoader(false);
                console.error(`Error fetching ${dashboardType} dashboard:`, error);
            });
    }, [1])

    useEffect(() => {
        if ((dashboardType === 'Home') || (!loadDashboard && !showDashboard && dashboardType === 'ESG' && (facility_ids.length === 0 || dashboardList.length === 0 || projectList.length === 0 || showLoader))) {
            return;
        }
        setShowLoader(true);
        const params = {
            section: dashboardType,
            type: 'Dashboard',
            client_id: dashboardType !== 'Home' ? client_id : null,
            facility_ids,
            dashboard_ids: dashboardList,
            pids: projectList,
        }

        axios.post('/api/v1/report/superset-embedd', params).then((resp) => {
            setShowLoader(false);
            const response = resp?.data?.data;
            if (!response?.guestToken) {
                return;
            }
            setSupersetGuestToken(response?.guestToken);
            setSupersetResourceList(response.resource_list);
        }).catch(ex => {
            setShowLoader(false);
            console.error(ex);
        });
    }, [showDashboard, loadDashboard]);

    if (showLoader) {
        return (
            <div className='w3-center' style={{ marginTop: 30 }}>
                <CircularProgress />
            </div>
        )
    }

    return (
        <Grid>
            {(dashboardType !== 'Home' && (
                <div style={{ display: showLoader ? 'none' : 'block' }} id="superset-container">
                    {supersetResourceList?.map((item) => (
                        <SupersetGraph
                            key={`graph-${item.id}`}
                            dashboardHeight={dashboardHeight}
                            dashboardId={item.id}
                            dashBoardIntId={dList?.find( d =>  d.value === item.id)}
                            dashboardType={dashboardType}
                            supersetGuestToken={supersetGuestToken}
                            projects = {projectList}
                        />
                    ))}
                </div>
            ))}

            {dashboardType === 'Home' && (
                <>
                    <HomeDashboard
                        homeDashboardData={homeDashboardData}
                        projectList={projectList}
                        clientId={client_id}
                    />
                    <SensorHealth
                        clientId={client_id}
                        projectList={projectList}
                    />
                </>
            )}
        </Grid>
    )
}



export  function SustDashboard(props) {

    const dispatch = useDispatch();
    const dashboardResponses = useSelector(item => item.dashboardResponses); 
    const { dashboardType, dashboardList = [], client_id = null, facility_ids = [], projectList = []  } = props; 
        const [showLoader, setShowLoader] = useState(false);  
 

    const dashboardApiMap = {
        'cd4ec559-97fa-43a5-8331-4f5987849f96': getSTPOpexCostIndexQueryData,
        '89dfdd00-6321-4115-82fb-4b7c2a887db2': getSTPEnergyIndexQueryData,
        '40ea467a-c0b2-4db6-96bf-d2052ce643b8': getETPWaterBalanceQueryData,
        'ece4d126-5c2f-4541-a6f3-d93619fadfe2': getETPEnergyIndexQueryData,
        '481cdaf5-4073-4ea7-9c8d-3ed3267745ed': getETPOpexCostIndexQueryData,
        '91f3c2f4-f983-4c48-9b86-6f692deacc74': getWTPWaterBalanceQueryData,
        'a660af0a-f23e-4ebd-904e-e3f1c1fcdcbf': getWTPEnergyIndexQueryData,
        '9931b2d3-b110-4f10-a164-af802d0b49fa': getSTPWaterBalanceQueryData,
        'fbe4f414-8001-4442-a9ab-80025d0b5490': getWTPWaterQualityParamIndexQueryData,
        '12da7485-484f-41d9-924a-05621d616332': getSTPWaterQualityParamIndexQueryData
    };

    const transformDashboardData = (res) => {
        const { legend: { label } = {}, data: rawData = [], max, scaleType } = res.data.config || {};
        const groupedByMonth = {};
        rawData.forEach(({ ts, facility_short_name, project_name, value, legend }) => {
            if (value == null) return;

            const gpLabel = legend ? `${project_name} - ${legend} - ${facility_short_name}` : `${project_name} - ${facility_short_name}`;
            const month = moment(ts).format('YYYY-MM-01');
        
            if (!groupedByMonth[month]) {
              groupedByMonth[month] = { month };
            }
        
            groupedByMonth[month][gpLabel] = value;
          });
        
        const transformedData = Object.values(groupedByMonth);
        
        return { data: transformedData, title: label, max, scaleType };
    } 
    useEffect(()=>{
        setShowLoader(false);
    },[dashboardResponses])
    useEffect(() => {
        if (facility_ids.length === 0 || dashboardList.length === 0 || projectList.length === 0 || showLoader) {
            return;
        }
        const params = {
            facilities: facility_ids,
            pids: projectList,
        } 
        
        const removeList= dashboardResponses.filter(item => !dashboardList.some(d => d.key == item.dashboardId));
        dispatch({type:'REMOVE_DASHBOARD',data:removeList});
        for(const dashboardId of dashboardList){
            if(dashboardResponses.find(item => item.dashboardId == dashboardId.key)){
                continue;
            }

            const apiFunc = dashboardApiMap[dashboardId.key];
            if (!apiFunc) {
                continue;
            } 
            setShowLoader(true);
            dispatch(apiFunc(params)).then((res) => { 
                const transformed = transformDashboardData(res); 
                 dispatch({ 
                    type:'UPDATE_DASHBOARD', 
                    data:{
                        dashboardId,
                        position: dashboardId.position ?? 0,
                        ...transformed
                    }
                });
            });

        }
        setShowLoader(false);
    }, [dashboardList]);

    if (showLoader) {
        return (
            <div className='w3-center' style={{ marginTop: 30 }}>
                <CircularProgress />
            </div>
        )
    }

    return (
        <Grid>
            <div style={{ display: showLoader ? 'none' : 'block' }} id="superset-container">
            {dashboardResponses
                ?.slice()
                .sort((a, b) => a.position - b.position)
                .map((item) => (
                    <SustainabilityGraphs 
                    key={item.dashboardId.key}
                    dashboardId={item.dashboardId.key}
                    dashboardType={dashboardType}
                    projects={projectList}
                    responseData={item.data}
                    chartTitle={item.title}
                    maxRange={item.max}
                    scaleType={item.scaleType}
                    facilities={facility_ids}
                    />
                ))
            }
              </div> 
        </Grid>
    )
}